// extracted by mini-css-extract-plugin
module.exports = {"value":"inventory_info-module_value_1xIwW"};